var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-icon",attrs:{"src":require("@/assets/edit.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }